<template>
  <div>
    <v-app-bar app :height="$vuetify.breakpoint.xsOnly ? 104 : 64" id="toolbar" light flat class="certi-toolbar" :class="{ 'toolbar-offline': $nuxt.isOffline }">
      <v-btn icon :aria-label="$t('navigationChrome.toggleMenu')" :aria-expanded="String(openMenu)" aria-controls="certi-sidebar" @click="drawerMenu()">
        <v-icon>mdi-menu</v-icon>
      </v-btn>

      <!-- Menú flotante con opciones - ENLACES RÁPIDOS -->
      <!-- <v-menu
          transition="slide-y-transition"
          v-model="menuGeneral"
          :nudge-width="250"
          offset-y
          bottom
          right
      >
        <template v-slot:activator="{ on }">
          <v-btn icon class="icon-menu" v-on="on">
            <v-icon>mdi-apps</v-icon>
          </v-btn>
        </template>

<v-card tile flat width="380px">
  <v-card-title class="text-uppercase body-1 primary font-weight-medium white--text">
    ENLACES RÁPIDOS
  </v-card-title>

  <v-toolbar color="primary" dark style="box-shadow: none !important;">
    <v-toolbar-title class="overline" style="font-size: 12px !important; font-weight: 500; color: white !important;">
      ENLACES RÁPIDOS
    </v-toolbar-title>
  </v-toolbar>

  <v-card-text class="pa-2">
    <v-row no-gutters>
      <v-col cols="6" class="pa-1" v-for="(item, index) in enlacesRapidos" :key="index">
        <v-card>
          <v-list-item class="cursor-pointer" @click="linkTo(item.link)">
            <v-list-item-icon class="mr-3">
              <v-icon :color="item.color_icon">{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content class="text-uppercase caption">
              {{ item.name.es_ES }}
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
    </v-row>
  </v-card-text>

</v-card>

</v-menu> -->

      <v-btn icon :aria-label="$t('navigationChrome.back')" @click="goBack()">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>

      <v-toolbar-title class="certi-toolbar__title" :title="currentPageTitle">
        {{ currentPageTitle }}
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <div class="certi-toolbar__actions">
      <span class="certi-toolbar__divider" aria-hidden="true"></span>

      <v-btn icon v-if="$nuxt.isOffline">
        <v-icon class="icon-menu">mdi-lightning-bolt-circle</v-icon>
      </v-btn>

      <!-- <v-btn icon>
        <v-icon class="icon-menu" @click="linkTo('dashboard')">mdi-monitor-dashboard</v-icon>
      </v-btn> -->

      <!-- NOTIFICACIONES -->
      <v-badge :value="!!notificacionesPendientes.length" :content="notificacionesPendientes.length" offset-y="20"
        offset-x="20" color="blue">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon :aria-label="$t('componentsDashboardCliente.notificaciones')" @click="ui.showNotificaciones = true" v-bind="attrs" v-on="on">
              <v-icon class="icon-menu">mdi-bell-ring</v-icon>
            </v-btn>
          </template>
          <span> {{ $t('componentsDashboardCliente.notificaciones') }} </span>
        </v-tooltip>
      </v-badge>

      <!-- ENVIAR EMAIL, when click show a menu with 2 options-->
      <v-menu v-if="isAuditoria" offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon :aria-label="$t('documentsUploader.notifyEmail')" v-bind="attrs" v-on="on">
            <v-icon>mdi-email-send</v-icon>
          </v-btn>
        </template>

        <v-card>
          <v-card-title class="primary">
            <span class="text-uppercase body-1 white--text"> {{ $t('documentsUploader.notifyEmail') }} </span>
          </v-card-title>

          <v-list>
            <v-list-item @click="sendOT(); ui.showEnviarEmail = false" :disabled="disabledOT">
              <v-list-item-icon>
                <v-icon color="primary" :disabled="disabledOT" >mdi-file-send</v-icon>
              </v-list-item-icon>
              <v-list-item-content class="text-uppercase caption">
                Enviar Orden de trabajo
              </v-list-item-content>
            </v-list-item>

            <v-divider></v-divider>

            <v-list-item @click="sendPA(); ui.showEnviarEmail = false" :disabled="disabledPA">
              <v-list-item-icon>
                <v-icon color="primary" :disabled="disabledPA">mdi-clipboard-text</v-icon>
              </v-list-item-icon>
              <v-list-item-content class="text-uppercase caption">
                Enviar Plan de Auditoria
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-menu>



      <!-- RESUMEN -->

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-if="verResumen" icon :aria-label="$t('solicitudes.resumen')" @click="openResumen()" v-bind="attrs" v-on="on">
            <v-icon class="icon-menu">mdi-ballot-outline</v-icon>
          </v-btn>
          <v-btn v-else icon class="chrome-action--disabled" aria-disabled="true" :aria-label="$t('solicitudes.resumen')" v-bind="attrs" v-on="on">
            <v-icon>mdi-ballot-outline</v-icon>
          </v-btn>
        </template>
        <span>{{$t('solicitudes.resumen')}}</span>
      </v-tooltip>

      <!-- DOCUMENTOS -->
      <template v-if="!$nuxt.isOffline">
        <v-badge :value="!!documentos.length" :content="documentos.length" offset-y="20" offset-x="20" color="blue">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-if="showGestorDocumentalIcon" icon :aria-label="$t('documentos.title')" @click="openGestorDocumental()" v-bind="attrs" v-on="on">
                <v-icon class="icon-menu">mdi-folder-open</v-icon>
              </v-btn>
              <v-btn v-else icon class="chrome-action--disabled" aria-disabled="true" :aria-label="$t('documentos.title')" v-bind="attrs" v-on="on">
                <v-icon>mdi-folder-open</v-icon>
              </v-btn>
            </template>
            <span> {{ $t('documentos.title') }} </span>
          </v-tooltip>
        </v-badge>
      </template>

      <!-- FORMATOS -->
      <template v-if="!$nuxt.isOffline">
        <v-badge v-if="!$nuxt.isOffline && $refs.formatos" :value="!!$refs.formatos.formatosCount"
          :content="$refs.formatos.formatosCount" offset-y="20" offset-x="20" color="blue">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon :aria-label="$t('pagesAdminEmpresasUuid.formats')" @click="openFormatos()" v-bind="attrs" v-on="on">
                <v-icon class="icon-menu">mdi-file-document-edit</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('pagesAdminEmpresasUuid.formats') }}</span>
          </v-tooltip>
        </v-badge>
      </template>

      <!-- LISTAS DE VALIDACIÓN -->
      <template v-if="!$nuxt.isOffline">
        <v-badge :value="listaValidacion" content="!" color="error" offset-y="20" offset-x="20">
          <v-btn icon :aria-label="$t('navigationChrome.validationLists')" @click="openListaValidacion()" v-if="verListaValidacion">
            <v-icon class="icon-menu">mdi-format-list-checkbox</v-icon>
          </v-btn>
          <v-btn v-else icon class="chrome-action--disabled" aria-disabled="true" :aria-label="$t('navigationChrome.validationLists')">
            <v-icon>mdi-format-list-checkbox</v-icon>
          </v-btn>
        </v-badge>
      </template>
      </div>
    </v-app-bar>

    <!-- MENÚ LATERAL -->
    <v-navigation-drawer v-model="$store.state.menu.openMenu" app dark width="275px"
      id="certi-sidebar" class="certi-sidebar" :aria-label="$t('navigationChrome.navigation')">
      <div class="certi-sidebar__brand">
        <v-img :src="require('../static/logo_horizontal.png')" alt="Certiapp" contain height="80" width="100%" max-width="250"></v-img>
      </div>

      <div class="certi-sidebar__account">
          <v-avatar size="36" class="certi-sidebar__avatar">
            <v-icon size="21">mdi-account-outline</v-icon>
          </v-avatar>
          <div class="certi-sidebar__identity">
            <span class="certi-sidebar__username" :title="$auth.user.username">{{ $auth.user.username }}</span>
            <span class="certi-sidebar__account-label">{{ $t('navigationChrome.account') }}</span>
          </div>
          <!-- Menú flotante con opciones generales del menú -->
          <v-menu v-if="!$nuxt.isOffline" transition="slide-y-transition" v-model="menuOpcionesGenerales"
            content-class="certi-account-popover" min-width="260" max-width="280" offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon small :aria-label="$t('navigationChrome.accountOptions')" v-bind="attrs" v-on="on">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-card tile flat light class="certi-account-menu">
              <v-card-title class="certi-account-menu__header">
                <span class="certi-account-menu__username">{{ $auth.user.username }}</span>
                <span class="certi-account-menu__subtitle">{{ $t('navigationChrome.account') }}</span>
              </v-card-title>

              <v-list-item @click="linkTo('dashboard')">
                <v-list-item-icon>
                  <v-icon>mdi-monitor-dashboard</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  {{ $t('menu.dashboard') }}
                </v-list-item-content>
              </v-list-item>

              <v-divider></v-divider>

            <v-list-item @click="linkTo('settings')" v-if="isEmpresa">
                <v-list-item-icon>
                  <v-icon>mdi-cog-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  {{ $t('portalNavigation.gestionPreferencias') }}
                </v-list-item-content>
              </v-list-item>  
            <v-list-item @click="linkTo('settings')" v-if="isCliente">
                <v-list-item-icon>
                  <v-icon>mdi-cog-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  {{ $t('portalNavigation.gestionPreferencias') }}
                </v-list-item-content>
              </v-list-item>  

              <v-divider></v-divider>

              <v-list-item class="certi-account-menu__logout" @click="dialogConfirmExit = true">
                <v-list-item-icon>
                  <v-icon>mdi-logout</v-icon>
                </v-list-item-icon>
                <v-list-item-content> {{ $t('portalNavigation.desconectar') }} </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-menu>
      </div>

      <v-list id="menu" class="certi-sidebar__links transparent">
        <div>
          <div v-for="(item, index) in menu" :key="index">
            <!-- templated used to filter allowed while offline -->
            <template v-if="showWhileOffline(item)">
              <!-- LINKS -->
              <v-list-item v-if="item.submenus.length == 0" link @click="linkTo(item.link)"
                :class="{ 'is-current': activeMenuItem === item }" :aria-current="activeMenuItem === item ? 'location' : null">
                <v-list-item-icon v-if="item.icon" class="mr-3">
                  <v-icon v-text="item.icon"></v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ $t('menu.' + (item.modulo || 'sin_modulo')) }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <!-- MENÚS -->
              <v-list-group v-else color="#00dcc6" :class="{ 'is-current-section': isCurrentLink(item.link) || item.submenus.some(submenu => isCurrentLink(submenu.link)) }">
                <template v-slot:activator>
                  <v-list-item-icon v-if="item.icon" class="mr-3">
                    <v-icon v-text="item.icon"></v-icon>
                  </v-list-item-icon>
                  <v-list-item-title @click="linkTo(item.link)">
                    {{ $t('menu.' + (item.modulo || 'sin_modulo')) }}
                  </v-list-item-title>
                </template>

                <template v-for="(submenu, indexSubmenu) in item.submenus">
                  <v-list-item link class="certi-sidebar__sublink" v-if="showWhileOffline(submenu)" :key="indexSubmenu"
                    :class="{ 'is-current': activeMenuItem === submenu }" :aria-current="activeMenuItem === submenu ? 'location' : null"
                    @click="linkTo(submenu.link)">
                    <v-list-item-title>{{ $t('menu.' + (submenu.modulo || 'sin_modulo')) }}</v-list-item-title>
                    <v-list-item-icon v-if="submenu.icon">
                      <v-icon v-text="submenu.icon"></v-icon>
                    </v-list-item-icon>
                  </v-list-item>
                </template>
              </v-list-group>
            </template>
          </div>
        </div>
      </v-list>
    </v-navigation-drawer>

    <!-- Confirmación Logout -->
    <Confirmation v-model="dialogConfirmExit" :text="$t('portalNavigation.aprobarDesconexion')" colorButton="error"
      :textButton="$t('portalNavigation.exitButton')" @confirm="logout()" />

    <!-- GESTOR DOCUMENTAL -->
    <GestorDocumental v-model="gestorDocumental" />

    <!-- Gestor Documental v2 -->
    <Share />
    <Uploader />
    <Downloader />

    <!-- Formatos -->
    <Formatos ref="formatos" v-model="ui.showFormatos" @close="ui.showFormatos = false" />

    <!-- LISTAS DE VALIDACIÓN -->
    <ListasValidacion v-model="ui.showListaValidacion" />

    <!-- NOTIFICACIONES -->
    <Notificaciones v-model="ui.showNotificaciones" @close="ui.showNotificaciones = false" />

    <!-- RESUMEN AUDITORIA,CERTIFICADOS,DITCTAMEN ETC... -->
    <Resumen v-model="ui.showResumen" :route_object="this.$route" @close="ui.showResumen = false" />

    <!-- Offline Queue -->
    <OfflineQueue />
    <OfflineHelper />

    <!-- Excel bridge (import and export) -->
    <ExcelBridge />

    <Signatures />

  </div>
</template>

<script>
import { initializeSessionSection } from '~/utils/session-readiness'
/**
 * @project: certiapp-nuxt
 * @file:    components/Menu.vue
 * @desc:    ...
 * -------------------------------------------
 * Created Date: 1st February 2021
 * Last Modified: Wed Jul 12 2023
 **/

import text from '~/models/labels'
// import menuJSON from '~/models/menu'

import GestorDocumental from '~/components/GestorDocumental'
import Share from '~/components/Share'
import Uploader from '~/components/documentsUploader'
import Downloader from '~/components/documents/downloader'
import Signatures from '~/components/signatures/Sign'
import ExcelBridge from '~/components/ExcelBridge'
import OfflineQueue from '~/components/offline/queue'
import OfflineHelper from '~/components/offline/helper'
import ListasValidacion from '~/components/ListasValidacion'
import Notificaciones from '~/components/Notificaciones'
import Confirmation from '~/components/Confirmation'
import ROLE from '~/models/role'
import { mapState } from 'vuex'
import Formatos from '~/components/Formatos'
import Resumen from '~/components/Resumen'

export default {
  name: 'Menu',
  components: {
    GestorDocumental,
    Share,
    Uploader,
    Downloader,
    Signatures,
    ExcelBridge,
    OfflineQueue,
    OfflineHelper,
    Formatos,
    ListasValidacion,
    Notificaciones,
    Confirmation,
    Resumen,
  },

  data: () => ({
    toolbar: null,
    dialogConfirmExit: false,

    db: {
      menu: [],
    },
    disabledOT: true,
    disabledPA: true,
    menuOpcionesGenerales: false,
    menuGeneral: false,
    gestorDocumental: false,
    ui: {
      text: text,
      showEnviarEmail: false,
      showFormatos: false,
      showListaValidacion: false,
      showNotificaciones: false,
      showResumen: false,
    },
  }),

  computed: {
    activeMenuItem() {
      // Una única opción activa: la ruta visible más específica, también en páginas de detalle.
      const links = this.menu.filter(this.showWhileOffline).reduce((all, item) => {
        return all.concat(item.submenus.length ? item.submenus.filter(this.showWhileOffline) : item)
      }, [])

      return links.reduce((current, item) => {
        if (!this.isCurrentLink(item.link)) return current
        if (!current || this.menuLinkPath(item.link).length > this.menuLinkPath(current.link).length) {
          return item
        }
        return current
      }, null)
    },
    currentPageTitle() {
      if (this.$route.path === '/dashboard') return this.$t('menu.dashboard')
      const links = this.menu.reduce((all, item) => all.concat(item, item.submenus || []), [])
      const current = links.filter(item => this.isCurrentLink(item.link))
        .sort((a, b) => b.link.length - a.link.length)[0]
      if (current && current.modulo && this.$te('menu.' + current.modulo)) {
        return this.$t('menu.' + current.modulo)
      }
      const title = this.$store.state.menu.pageTitle
      if (!title) return 'Certiapp'
      const key = 'menu.' + title.toLowerCase()
      return this.$te(key) ? this.$t(key) : title
    },
    ...mapState({
      menuEmpresa: (state) => state.menu.menuEmpresa,
      openMenu: (state) => state.menu.openMenu,
      verGestorDocumental: (state) => state.formatos.list,
      listaValidacion: (state) => state.listas_validacion.lista,
      verListaValidacion: (state) => state.listas_validacion.verListaValidacion,
      formatos: (state) => state.formatos.list,
    }),

    locale() {
      return this.$i18n.locale
    },

    cod_empresa() {
      return this.$auth.user.empresa.codigo
    },

    roles() {
      return this.$auth.user.roles
    },

    verFormatos() {
      return this.$store.getters['formatos/verFormatos']
    },

    verResumen() {
      return this.$store.getters['formatos/verFormatos']
    },

    documentos() {
      return this.showGestorDocumentalIcon ? this.$store.getters['gestor_documental/documentos'] : []
    },

    notificacionesPendientes() {
      return this.$store.getters['notificaciones/notificacionesPendientes']
    },

    isRoot() {
      return this.$auth.user.roles.includes('ROLE_ROOT')
    },

    isEmpresa() {
      return (
        this.$auth.user.roles.includes('ROLE_EMPRESA') ||
        this.$auth.user.roles.includes('ROLE_ADMIN')
      )
    },
    isCliente() {
      return (
        this.$auth.user.roles.includes('ROLE_CLIENT')
      )
    },
    isAuditor() {
      return this.$auth.user.roles.includes('ROLE_AUDITOR')
    },
    isAuditorAdmin() {
      return this.$auth.user.roles.includes('ROLE_AUDITOR_ADMIN')
    },
    isAdminGroup() {
      return this.$auth.user.roles.includes('ROLE_ADMIN_GROUP')
    },

    hasAdminRole() {
      return (
        this.$auth.user.tipo === 'admin' &&
        this.$auth.user.roles.includes(ROLE.ROLE_ADMIN) &&
        this.$auth.user.empresaOwner.configuracion.addonCertiappMovil === true &&
        this.$auth.user.empresa.configuracion.opcionesAvanzadasParaEmpresa.certiappMovil === true
      )
    },

    showGestorDocumentalIcon() {
      if (this.$route.path.indexOf('nueva') !== -1) return false
      if (this.$route.name.indexOf('uuid') !== -1) return true
    },

    //+-------------------------------------------------
    // menu()
    // Computed with menu elements
    // UPDATED: Now comes from api and users and roles are already filtered
    // -----
    // Created on Mon Mar 14 2022
    // Updated on Thu Jan 26 2023
    //+-------------------------------------------------
    menu() {
      // Ocultación temporal: conservar las rutas y los datos originales del menú.
      const hiddenLinks = ['dictamenes/lotes', 'revisiones/lotes']
      const isVisible = (item) => {
        const link = (item.link || '').split(/[?#]/)[0].replace(/^\/+|\/+$/g, '')
        return !hiddenLinks.includes(link)
      }

      return this.db.menu.filter(isVisible).map((item) => ({
        ...item,
        submenus: item.submenus.filter(isVisible),
      }))
    },

    isAuditoria() {
      return this.$route.name === 'auditorias-uuid'
    },
    
  },

  methods: {
    menuLinkPath(link) {
      if (typeof link !== 'string' || !link || link === '#') return ''
      return '/' + link.split(/[?#]/)[0].replace(/^\/+|\/+$/g, '')
    },
    isCurrentLink(link) {
      const path = this.menuLinkPath(link)
      if (!path) return false
      return path !== '/' && (this.$route.path === path || this.$route.path.startsWith(path + '/'))
    },
    notification() {
      this.$store.commit('notification/show', { text: 'soy una notificacion' })
    },

    changeStatusOT(newValue) {
      this.disabledOT = newValue
    },

    changeStatusPA(newValue) {
      this.disabledPA = newValue

    },

    async logout() {
      await this.$auth.logout()
      this.$router.push('/login')
    },

    goBack() {
      console.log('23')
      this.$router.go(-1)
    },

    linkTo(link) {
      if (link) {
        // this.$store.commit('menu/update', link)
        this.$router.push('/' + link)
      }
    },

    // //+-------------------------------------------------
    // // filterSubmenu()
    // // Tries to filter the submenu based on the role
    // // -----
    // // Created on Tue Sep 27 2022
    // //+-------------------------------------------------
    // filterSubmenu(element) {
    //   const roles = this.$auth.user.roles

    //   if (element.role && !roles.includes(element.role)) return false
    //   if (element.notFor && element.notFor.includes(this.cod_empresa)) return false
    //   if (element.onlyFor && !element.onlyFor.includes(this.cod_empresa)) return false

    //   return true
    // },

    //+-------------------------------------------------
    // showWhileOffline()
    // Returns true if the app is offline and the item has offline support
    // Returns true if the application is online
    // -----
    // Created on Wed Mar 02 2022
    //+-------------------------------------------------
    showWhileOffline(item) {
      if (!this.$nuxt.isOffline) return true

      if (item.modulo == 'auditorias' && item.submodulo !== 'checklists') return true
      if (item.offline) return true
      return false
    },

    // showSubmenuEmpresa(menu, submenu) {
    //   if (this.$auth.user.roles.includes('ROLE_ROOT')) return true
    //   const permisos = this.$auth.user.permisos
    //   if (permisos) {
    //     const roles = this.$auth.user.roles
    //     const canList = permisos.some((e) => {
    //       return (
    //         // e.can_-list &&
    //         e.can_config?.canList &&
    //         e.modulo === menu.modulo &&
    //         e.submodulo === submenu.submodulo &&
    //         roles.includes(e.role.name)
    //       )
    //     })
    //     return canList
    //   }
    //   return false
    // },

    openCloseMenu() {
      this.$store.commit('menu/drawerMenu', this.openMenu)
    },

    drawerMenu() {
      this.$store.commit('menu/drawerMenu', !this.openMenu)
    },

    controlToolbarSize() {
      if (!this.openMenu) {
        this.toolbar.classList.add('toolbar-no-menu')
        this.toolbar.classList.remove('toolbar-width-menu')
      } else {
        this.toolbar.classList.remove('toolbar-no-menu')
        this.toolbar.classList.add('toolbar-width-menu')
      }
    },

    openGestorDocumental() {
      if (this.$route.name.indexOf('uuid') !== -1) this.gestorDocumental = true
    },

    openFormatos() {
      if (!this.ui.showFormatos) this.$nuxt.$emit('formatos:open')
      this.ui.showFormatos = !this.ui.showFormatos
    },

    openResumen() {
      if (this.$route.name.indexOf('uuid') !== -1) this.ui.showResumen = true
    },

    openListaValidacion() {
      if (this.$route.name.indexOf('uuid') !== -1) this.ui.showListaValidacion = true
    },

    async getMenu() {
      let jxr = await this.$store.dispatch('layout/menu')
      if (jxr) {
        const menu = jxr.map((item) => ({
          ...item,
          submenus: Object.values(item.submenus),
        }))
        this.db.menu = this.withGestionProductos(this.withOfflineManagementForAdmin(menu))
      }
    },

    withGestionProductos(menu) {
      const user = this.$auth.user
      if (user?.tipo !== 'admin' || !user?.roles?.includes(ROLE.ROLE_ADMIN) ||
          user?.empresaOwner?.configuracion?.addonGestionProductos !== true) return menu

      return menu.map((item) => {
        if (item.modulo !== 'configuracion') return item
        if (item.submenus.some((sub) => sub.link === 'configuraciones/cargar-productos')) return item
        return {
          ...item,
          submenus: [...item.submenus, {
            modulo: 'gestion_productos',
            submodulo: 'gestion_productos',
            link: 'configuraciones/cargar-productos',
            icon: 'mdi-package-variant-closed',
            rol: ROLE.ROLE_ADMIN,
          }],
        }
      })
    },

    withOfflineManagementForAdmin(menu) {
      if (!this.hasAdminRole) return menu

      return menu.map((item) => {
        const submenus = item.submenus
        const isAuditoriasMenu =
          item.modulo === 'auditorias' ||
          item.modulo === 'auditoriasMenu' ||
          submenus.some((submenu) => submenu.link === 'auditorias')

        if (!isAuditoriasMenu) return item

        const exists = submenus.some((submenu) => submenu.link === 'auditorias/gestion-offline')
        if (exists) return item

        const auditoriasIndex = submenus.findIndex((submenu) => submenu.link === 'auditorias')
        const gestionOffline = {
          modulo: 'gestion_offline',
          submodulo: 'gestion-offline',
          link: 'auditorias/gestion-offline',
          icon: 'mdi-cloud-download-outline',
          rol: ROLE.ROLE_ADMIN,
        }
        const nextSubmenus = [...submenus]

        if (auditoriasIndex === -1) nextSubmenus.push(gestionOffline)
        else nextSubmenus.splice(auditoriasIndex + 1, 0, gestionOffline)

        return {
          ...item,
          submenus: nextSubmenus,
        }
      })
    },

    async init() {
      await this.getMenu()
    },
    getMailErrorDetail(error) {
      const hydraDescription = error?.response?.data?.['hydra:description'] || ''
      const genericMessage = error?.response?.data?.message || error?.message || ''
      const detail = hydraDescription || genericMessage
      const detailLower = detail.toLowerCase()

      if (
        detailLower.includes('recipient address rejected') ||
        detailLower.includes('user unknown in virtual mailbox table') ||
        detailLower.includes('550 5.1.1')
      ) {
        return 'Uno o varios destinatarios tienen un email inválido o inexistente.'
      }

      if (detailLower.includes('connection') && detailLower.includes('smtp')) {
        return 'No se pudo conectar con el servidor de correo.'
      }

      if (detail) return detail
      return 'Error desconocido al enviar el correo.'
    },

    notifyMailResult(type, response, error) {
      const isOT = type === 'OT'
      const documento = isOT ? 'Orden de trabajo' : 'Plan de auditoría'

      if (!error) {
        const status = response?.data?.status || response?.status || ''
        const text = `${documento} enviada correctamente por correo.`
        this.$store.commit('notification/show', {
          text,
          color: 'success',
          timeout: 4000,
        })
        return
      }

      const detail = this.getMailErrorDetail(error)
      this.$store.commit('notification/show', {
        text: `No se pudo enviar ${documento} por correo. ${detail}`,
        color: 'error',
        timeout: 7000,
      })
    },

    async sendOT() {
      try {
        const response = await this.$store.dispatch('auditorias/sendOT', this.$route.params.uuid)
        this.notifyMailResult('OT', response, null)
      } catch (error) {
        this.notifyMailResult('OT', null, error)
      }
    },
  
    async sendPA() {
      try {
        const response = await this.$store.dispatch('auditorias/sendPA', this.$route.params.uuid)
        this.notifyMailResult('PA', response, null)
      } catch (error) {
        this.notifyMailResult('PA', null, error)
      }
    },
  },

  mounted() {
    this.toolbar = document.getElementById('toolbar')
    return initializeSessionSection(this, 'navigation')
  },

  created() {
    this.$nuxt.$on('changeStatusOT', ($event)=> this.changeStatusOT($event))
    this.$nuxt.$on('changeStatusPA', ($event)=> this.changeStatusPA($event))
  },

}
</script>

<style scoped>
.certi-toolbar.v-app-bar,
.certi-sidebar.v-navigation-drawer {
  background: radial-gradient(ellipse at 0 0, rgba(66, 131, 149, 0.23), transparent 55%),
    linear-gradient(165deg, #1b3349 0%, #14263b 65%, #102335 100%) !important;
}

.certi-toolbar.v-app-bar {
  color: #f1f7fa !important;
  border-bottom: 1px solid rgba(185, 231, 235, 0.22);
  box-shadow: 0 3px 18px rgba(18, 40, 59, 0.12) !important;
}

.certi-toolbar ::v-deep .v-toolbar__content {
  padding-right: 20px;
  padding-left: 16px;
}

.certi-toolbar ::v-deep .v-btn--icon {
  color: #d8e4ed !important;
  border-radius: 11px;
  margin: 0 2px;
  transition: background-color 150ms ease, color 150ms ease;
}

.certi-toolbar ::v-deep .v-icon {
  color: inherit !important;
  font-size: 22px;
}

.certi-toolbar ::v-deep .v-btn--icon:not(.chrome-action--disabled):hover {
  color: #72e6d5 !important;
  background: rgba(53, 214, 195, 0.12);
}

.certi-toolbar ::v-deep .chrome-action--disabled {
  color: #728b9e !important;
  cursor: not-allowed;
}

.certi-toolbar__title {
  min-width: 0;
  padding-left: 14px;
  font-size: 17px;
  font-weight: 600;
  letter-spacing: -0.25px;
}

.certi-toolbar__actions {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: 2px;
}

.certi-toolbar__divider {
  height: 24px;
  width: 1px;
  margin: 0 12px;
  background: rgba(185, 231, 235, 0.22);
}

.certi-toolbar.toolbar-offline {
  background: repeating-linear-gradient(-45deg, #243a49, #243a49 10px, #30444d 10px, #30444d 20px) !important;
  border-bottom-color: #c9a958;
}

.certi-sidebar.v-navigation-drawer {
  border-right: 1px solid rgba(185, 231, 235, 0.22);
  box-shadow: inset -1px 0 rgba(255, 255, 255, 0.025), 6px 0 26px rgba(15, 33, 49, 0.06);
}

.certi-sidebar ::v-deep .v-navigation-drawer__content {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.certi-sidebar__brand {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  min-height: 100px;
  padding: 10px 12px;
}

.certi-sidebar__account {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: 11px;
  min-height: 68px;
  margin: 0 14px 18px;
  padding: 12px 10px;
  border: 1px solid transparent;
  border-radius: 4px;
  background: #344e62;
}

.certi-sidebar__avatar {
  background: rgba(53, 214, 195, 0.12);
  border: 1px solid rgba(85, 224, 206, 0.24);
  color: #8be9dc;
}

.certi-sidebar__avatar .v-icon {
  color: inherit;
}

.certi-sidebar__identity {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 0;
  gap: 3px;
}

.certi-sidebar__username {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #f1f7fa;
  font-size: 13px;
  font-weight: 600;
}

.certi-sidebar__account-label {
  font-size: 11px;
  color: #adc1d0;
}

/* El contenido del menú se mueve fuera del drawer: no depender de ese ancestro. */
.certi-account-menu.v-card {
  background: #fff;
  color: #203c53;
}

.certi-account-menu .certi-account-menu__header {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 3px;
  padding: 16px;
  background: #c5e9e5;
  color: #203c48;
  border-bottom: 1px solid #a4d4cf;
  line-height: 1.5;
}

.certi-account-menu__username {
  max-width: 100%;
  overflow-wrap: anywhere;
  font-size: 14px;
  font-weight: 600;
}

.certi-account-menu__subtitle {
  color: #456768;
  font-size: 11px;
  font-weight: 400;
}

.certi-account-menu ::v-deep .v-list-item {
  min-height: 48px;
  padding: 0 16px;
  color: #203c53;
}

.certi-account-menu ::v-deep .v-list-item__icon {
  align-self: center;
  margin: 0 14px 0 0;
}

.certi-account-menu ::v-deep .v-icon {
  color: #0786a3;
  font-size: 20px;
}

.certi-account-menu ::v-deep .v-list-item__content {
  font-size: 13px;
  line-height: 1.5;
  padding: 12px 0;
}

.certi-account-menu ::v-deep .v-divider {
  border-color: #e6ebef;
}

.certi-account-menu ::v-deep .v-list-item:hover {
  background: #e5f9fc;
}

.certi-account-menu ::v-deep .v-list-item:not(.certi-account-menu__logout):hover .v-icon {
  color: #b52bb8;
}

.certi-account-menu ::v-deep .certi-account-menu__logout,
.certi-account-menu ::v-deep .certi-account-menu__logout .v-icon {
  color: #a5534d;
}

.certi-account-menu ::v-deep .certi-account-menu__logout:hover {
  background: #faf2f0;
}

.certi-account-menu ::v-deep .v-list-item:focus-visible {
  outline: 2px solid #087f7c;
  outline-offset: -2px;
}

.certi-sidebar #menu {
  flex: 1;
  min-height: 0;
  padding: 0 12px 20px;
  overflow-y: auto;
  overscroll-behavior: contain;
  scrollbar-width: thin;
  scrollbar-color: rgba(153, 192, 206, 0.3) transparent;
}

.certi-sidebar #menu::-webkit-scrollbar {
  display: block;
  width: 4px;
}

.certi-sidebar #menu::-webkit-scrollbar-thumb {
  background: rgba(153, 192, 206, 0.3);
  border-radius: 4px;
}

.certi-sidebar__links ::v-deep .v-list-item {
  min-height: 44px;
  margin-bottom: 4px;
  padding: 0 14px;
  border: 1px solid transparent;
  border-radius: 10px;
  color: #d8e4ed !important;
  transition: background-color 150ms ease, border-color 150ms ease, color 150ms ease;
}

.certi-sidebar__links ::v-deep .v-list-item__title {
  font-size: 13px;
  font-weight: 500;
  line-height: 1.5;
}

.certi-sidebar__links ::v-deep .v-list-item__icon {
  align-self: center;
  margin-top: 0;
  margin-bottom: 0;
}

.certi-sidebar__links ::v-deep .v-icon {
  color: #adc5d4;
  font-size: 20px;
}

.certi-sidebar__links ::v-deep .v-list-item:hover {
  background: rgba(0, 205, 234, 0.14);
  border-color: rgba(0, 205, 234, 0.3);
  color: #f1fdff !important;
}

.certi-sidebar__links ::v-deep .is-current-section > .v-list-group__header {
  background: rgba(0, 220, 198, 0.1);
  border-color: rgba(0, 220, 198, 0.22);
  color: #e9fffc !important;
}

.certi-sidebar__links ::v-deep .is-current-section > .v-list-group__header .v-icon {
  color: #00dcc6;
}

.certi-sidebar__links ::v-deep .is-current-section > .v-list-group__header:hover {
  background: rgba(0, 205, 234, 0.18);
  border-color: rgba(0, 205, 234, 0.3);
}

.certi-sidebar__links ::v-deep .v-list-item:not(.is-current):hover .v-icon,
.certi-sidebar__links ::v-deep .is-current-section > .v-list-group__header:not(.is-current):hover .v-icon {
  color: #e368d5;
}

.certi-sidebar__links ::v-deep .is-current,
.certi-sidebar__links ::v-deep .is-current:hover {
  background: #00dcc6;
  border-color: #00dcc6;
  color: #102b3c !important;
}

.certi-sidebar__links ::v-deep .is-current .v-icon,
.certi-sidebar__links ::v-deep .is-current:hover .v-icon {
  color: #102b3c;
}

.certi-sidebar__links ::v-deep .is-current .v-list-item__title {
  font-weight: 600;
}

.certi-sidebar__links ::v-deep .v-list-group__items {
  margin: 2px 0 8px 15px;
  padding: 5px 0 2px 8px;
  border-left: 1px solid rgba(167, 206, 220, 0.18);
  border-radius: 0 10px 10px 0;
  background: rgba(3, 17, 29, 0.14);
}

.certi-sidebar__links ::v-deep .certi-sidebar__sublink {
  min-height: 40px;
  padding-left: 18px;
}

.certi-sidebar ::v-deep .v-btn:focus-visible,
.certi-sidebar__links ::v-deep .v-list-item:focus-visible {
  outline: 2px solid #00cdea;
  outline-offset: -2px;
}

.certi-sidebar__links ::v-deep .is-current:focus-visible {
  outline-color: #102b3c;
}

.certi-toolbar ::v-deep .v-btn:focus-visible {
  outline: 2px solid #72e6d5;
  outline-offset: 1px;
}

@media (max-width: 599px) {
  .certi-toolbar ::v-deep .v-toolbar__content {
    flex-wrap: wrap;
    align-content: center;
    padding: 4px 12px;
  }

  .certi-toolbar__title {
    flex: 1;
    font-size: 15px;
    padding-left: 8px;
  }

  .certi-toolbar__actions {
    flex-basis: 100%;
    justify-content: flex-end;
    padding-top: 4px;
    margin-top: 4px;
    border-top: 1px solid rgba(185, 231, 235, 0.16);
  }

  .certi-toolbar__divider {
    display: none;
  }

  .certi-toolbar ::v-deep .v-btn--icon {
    width: 36px;
    height: 40px;
    margin: 0;
  }
}

@media (prefers-reduced-motion: reduce) {
  .certi-toolbar ::v-deep .v-btn,
  .certi-sidebar__links ::v-deep .v-list-item {
    transition: none;
  }
}

.toolbar-offline {
  background: repeating-linear-gradient(-45deg,
      rgba(96, 108, 188, 0.25),
      rgba(96, 109, 188, 0.25) 10px,
      rgba(70, 82, 152, 0.25) 10px,
      rgba(70, 82, 152, 0.25) 20px);
}

.v-navigation-drawer {
  z-index: 7 !important;
}

.shadow-1 {
  border: 0px !important;
  -webkit-box-shadow: 0 1px 15px 1px rgba(69, 65, 78, 0.08) !important;
  box-shadow: 0 1px 15px 1px rgba(69, 65, 78, 0.08) !important;
}

.toolbar-div {
  height: 64px;
}

.toolbar-width-menu {
  background: #f5f5f5 !important;
  box-shadow: 0 4px 15px 0 rgba(0, 0, 0, 0.09) !important;
  color: #727891 !important;
  z-index: 1;
  right: 0;
  left: 275px;
  position: fixed;
}

.toolbar-no-menu {
  background: #f5f5f5 !important;
  box-shadow: 0 4px 15px 0 rgba(0, 0, 0, 0.09) !important;
  color: #727891 !important;
  z-index: 1;
  right: 0;
  left: 0;
  position: fixed;
}

/* Hide scrollbar for Chrome, Safari and Opera */
#menu::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE and Edge */
#menu {
  -ms-overflow-style: none;
}
</style>

<style>
/* Clase exclusiva del contenedor que Vuetify inserta bajo v-app. */
.v-menu__content.certi-account-popover {
  margin-top: 6px;
  border: 1px solid #d6e0e7;
  border-radius: 3px;
  box-shadow: 0 6px 18px rgba(16, 35, 53, 0.16);
}
</style>
